import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';

import SxIcon from '../common/sxIcon';
import Tooltip from '../common/tooltip';
import SelectDropdown from '../common/selectDropdown';

import styles from './recipientVariablesModal.module.scss';

class RecipientVariablesModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onSave = this.onSave.bind(this);
  }

  onVariableChanged(id, event, { value }) {
    this.setState({ [id]: value });
  }

  onSave() {
    this.props.onSave(this.state);
  }

  isSaveDisabled() {
    const { recipientVariables = [] } = this.props;
    const filteredVariables = recipientVariables.filter((variable) => variable.options.length > 0);
    return Object.keys(this.state).length !== filteredVariables.length;
  }

  renderRecipientVariables() {
    const { recipientVariables = [] } = this.props;

    return recipientVariables.reduce((variables, variable) => {
      const { options = [] } = variable || {};

      if (options.length > 0) {
        variables.push(
          <div className={styles.row} key={variable.id}>
            <div className={styles.label}>{variable.name}</div>
            <div className={styles.selector}>
              <SelectDropdown
                fluid
                options={options}
                onChange={this.onVariableChanged.bind(this, variable.id)}
                value={this.state[variable.id]}
              />
            </div>
          </div>
        );
      }

      return variables;
    }, []);
  }

  render() {
    // TODO: add missing icon: question circle
    return (
      <Modal
        title="Recipient Variables"
        closeIcon={<SxIcon name="sx-cross" />}
        footer={
          <>
            <Button type="link" onClick={this.props.onCancel}>
              CANCEL
            </Button>
            <Button onClick={this.onSave} disabled={this.isSaveDisabled()}>
              <SxIcon name="sx-check" /> ACCEPT
            </Button>
          </>
        }
        visible
      >
        <div className={styles.modalContent}>
          <div className={styles.description}>
            This survey needs the following recipient values for Criteria to work properly.
            <Tooltip
              Component={<SxIcon name="question circle" />}
              tooltipText="If you do not set recipient variables, some questions will not behave as intended."
            />
          </div>
          {this.renderRecipientVariables()}
        </div>
      </Modal>
    );
  }
}

RecipientVariablesModal.propTypes = {
  recipientVariables: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default RecipientVariablesModal;
